import React from 'react';
import { autobind } from 'core-decorators';
import Lookup from '../componentes/select2';

@autobind
class TipoValorDesatualizadoLookup extends React.Component {
  render() {
    return <Lookup showSearch={false} labelKey="descricao" valueKey="id" url="/TipoValorDesatualizadoLookup" clearable={true} {...this.props} />;
  }
}

export default TipoValorDesatualizadoLookup;
